module.exports = __webpack_public_path__ + "static/ACaslonPro-Regular-1f63dcbea6f17c5ad9c85996d5e4661b.woff";